// Activity status
// TODO configure based on routes.js, or add help links
// to routes.js
export const supportSiteBaseURL = "https://support.amiralearning.com"

export const teacherInProductHelpLinks = [{
    pathname: '/teacher/reports/type/benchmark',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Benchmark-Report`
  },{
    pathname: '/teacher/reports/type/tracking',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Tracking-Report`
  },{
    pathname: '/teacher/reports/type/progress',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Progress-Report-to-monitor-Assessment-and-or-Practice-sessions-over-time`
  },{
    pathname: '/teacher/reports/type/parent',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Parent-Report-to-share-a-student-s-progress`
  },{
    pathname: '/teacher/reports/type/diagnostic',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Instructional-Recommendations-Report-to-inform-instruction`
  },{
    pathname: '/teacher/reports/type/readingrope',
    link: `${supportSiteBaseURL}/en/articles/5333690-how-do-i-use-the-instructional-recommendations-report`
  },{
    pathname: '/teacher/reports/type/skillsstatus',
    link: `${supportSiteBaseURL}/s/article/Skills-Status-Report`
  },{
    pathname: '/teacher/reports/type/skillsdiagnostic',
    link: `${supportSiteBaseURL}/s/article/Skills-Diagnostic-Report`
  },{
    pathname: '/teacher/reports/type/dyslexiarisk',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-data-from-the-Dyslexia-Risk-Screener`
  },{
    pathname: '/teacher/gradebook/activities',
    link: `${supportSiteBaseURL}`
  },{
    pathname: '/teacher/gradebook/scoring/',
    link: `${supportSiteBaseURL}/s/article/How-do-I-use-the-Practice-Scoring-Screen`
  }
];

export const studentInProductHelpLinks = {
  "enableMicrophoneGeneral": `${supportSiteBaseURL}/s/article/How-do-I-always-enable-the-microphone`,
  "enableMicrophoneChromeDesktop": `${supportSiteBaseURL}/s/article/How-do-I-always-enable-the-microphone-on-Chrome`,
  "enableMicrophoneFirefoxDesktop": `${supportSiteBaseURL}/s/article/How-do-I-always-enable-the-microphone-on-Firefox`,
  "enableMicrophoneSafariDesktop": `${supportSiteBaseURL}/s/article/How-do-I-always-enable-the-microphone-on-Safari`,
  "enableMicrophoneEdgeDesktop": `${supportSiteBaseURL}/s/article/How-do-I-always-enable-the-microphone-on-Microsoft-Edge`,
  "networkPingGeneral": `${supportSiteBaseURL}/s/article/What-are-the-technical-requirements`,
}

export const educatorSupportHelpLinks = {
  studentPracticeExperience: `${supportSiteBaseURL}/s/article/Experience-Amira-as-a-Student`,
  practiceErrorDetection: `${supportSiteBaseURL}/s/article/What-do-I-do-if-I-see-an-error-message`
}